import { Action } from '@ngrx/store';
import { IRegistrationEntry } from '../../models/registrationentry.model';

export enum RegistrationEntryActionType {
    FETCH_REGISTRATIONENTRIES = '[RegistrationEntry] Fetch RegistrationEntries',
    ADD_REGISTRATIONENTRY = '[RegistrationEntry] Add RegistrationEntry',
    SET_REGISTRATIONENTRY_TO_COMPLETE = '[RegistrationEntry] Set RegistrationEntry To Complete',
    DELETE_REGISTRATIONENTRY = '[RegistrationEntry] Delete RegistrationEntry',
}

export class FetchRegistrationEntryAction implements Action {
    readonly type = RegistrationEntryActionType.FETCH_REGISTRATIONENTRIES;
    constructor(public registrationEntries: IRegistrationEntry[]) {
        console.log("registrationEntries:" + JSON.stringify(registrationEntries));
     }
}

export class AddRegistrationEntryAction implements Action {
    readonly type = RegistrationEntryActionType.ADD_REGISTRATIONENTRY;
    constructor(public registrationEntry: IRegistrationEntry) { }
}

export class SetRegistrationEntryToCompleteAction implements Action {
    readonly type = RegistrationEntryActionType.SET_REGISTRATIONENTRY_TO_COMPLETE;
    constructor(public id: number) { }
}

export class DeleteRegistrationEntryAction implements Action {
    readonly type = RegistrationEntryActionType.DELETE_REGISTRATIONENTRY;
    constructor(public id: number) { }
}

export type RegistrationEntryAction = FetchRegistrationEntryAction
    | AddRegistrationEntryAction
    | SetRegistrationEntryToCompleteAction
    | DeleteRegistrationEntryAction;